import dynamic from 'next/dynamic'
import About from './About'
import Benefits from './Benefits'
const Lottie = dynamic(() => import('react-lottie'), { ssr: false })
import { useTranslation } from 'react-i18next'
import useLoadAnimations from '@hooks/useLoadAnimations'

type Props = {
  handleOpenJoinReferralModal: () => void
  isJoined: boolean
}

const animations = [
  {
    path: '/static/images/animations/trackYourInvitesAnimated.json',
    key: 'trackYourInvitesAnimated',
  },
  {
    path: '/static/images/animations/EarnFromEverySaleBlockAnimated.json',
    key: 'EarnFromEverySaleBlockAnimated',
  },
  {
    path: '/static/images/animations/Get200BlockAnimated.json',
    key: 'Get200BlockAnimated',
  },
  {
    path: '/static/images/animations/withdrawEarningsBlockAnimated.json',
    key: 'withdrawEarningsBlockAnimated',
  },
]

const ReferralsAbout = ({ handleOpenJoinReferralModal, isJoined }: Props) => {
  const { t } = useTranslation('referrals')
  const { animations: animationsData } = useLoadAnimations({
    animations,
  })

  return (
    <>
      <About
        title={t('about.earn_from_every_sale_title')}
        description={t('about.earn_from_every_sale_description')}
        // illustration={<EarnIllustration width={'100%'} height={'100%'} />}
        illustration={
          animationsData.EarnFromEverySaleBlockAnimated ? (
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: animationsData.EarnFromEverySaleBlockAnimated,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice',
                },
              }}
            />
          ) : (
            <></>
          )
        }
        direction="row"
        btnLabel={isJoined ? t('modal.goToDashboard') : t('startEarning')}
        onBtnClick={handleOpenJoinReferralModal}
      />
      <About
        title={t('about.get_200_per_tutor_title')}
        description={t('about.get_200_per_tutor_description')}
        // illustration={<InviteIllustration width={'100%'} height={'100%'} />}
        illustration={
          animationsData.Get200BlockAnimated ? (
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: animationsData.Get200BlockAnimated,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice',
                },
              }}
            />
          ) : (
            <></>
          )
        }
        direction="row-reverse"
        onBtnClick={handleOpenJoinReferralModal}
        animationBlockRatio="16.1/10.59"
        btnLabel={isJoined ? t('modal.goToDashboard') : t('startEarning')}
      />
      <Benefits onBtnClick={handleOpenJoinReferralModal} />
      <About
        title={t('about.track_invites_title')}
        description={t('about.track_invites_description')}
        // illustration={<TrackIllustration width={'100%'} height={'100%'} />}
        illustration={
          animationsData.trackYourInvitesAnimated ? (
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: animationsData.trackYourInvitesAnimated,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice',
                },
              }}
            />
          ) : (
            <></>
          )
        }
        direction="row"
        hideBtn={true}
        onBtnClick={handleOpenJoinReferralModal}
        btnLabel={isJoined ? t('modal.goToDashboard') : t('startEarning')}
      />
      <About
        title={t('about.withdraw_earnings_title')}
        description={t('about.withdraw_earnings_description')} // illustration={
        //   <div className="w-full bg-[#F7F7F7] py-14 px-8 sm:px-6 xl:py-0 xl:h-[484px] rounded-xl flex items-start xl:items-center flex-wrap justify-start sm:justify-center gap-4">
        //     {withdrawalItems.map((item) => (
        //       <div
        //         key={item.title}
        //         className="bg-white rounded-2xl flex flex-col py-8 px-5 gap-3 shadow-sm max-w-full w-full items-center sm:items-start sm:max-w-[172px]"
        //       >
        //         <div className="border-[1px] h-[53px] min-w-[53px] border-[#ebebeb] flex justify-center items-center rounded-full max-w-max">
        //           {item.icon}
        //         </div>
        //         <ItemTitle>{item.title}</ItemTitle>
        //       </div>
        //     ))}
        //   </div>
        // }
        illustration={
          animationsData.withdrawEarningsBlockAnimated ? (
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: animationsData.withdrawEarningsBlockAnimated,
                rendererSettings: {
                  preserveAspectRatio: 'xMidYMid slice',
                },
              }}
            />
          ) : (
            <></>
          )
        }
        direction="row-reverse"
        hideBtn={true}
        onBtnClick={handleOpenJoinReferralModal}
        animationBlockRatio="16.1/9.75"
        btnLabel={isJoined ? t('modal.goToDashboard') : t('startEarning')}
      />
    </>
  )
}

export default ReferralsAbout
